import { LEGAL_CONTACT, LEGAL_UPDATED_AT } from "./legal-config";
import LegalPageLayout, { LegalCallout, LegalSection } from "./LegalPageLayout";

export default function Remboursement() {
  return (
    <LegalPageLayout
      title="Annulation, résiliation et remboursement"
      topbarTitle="Annulation et remboursement"
      lead="Cette page distingue clairement l’annulation de l’essai, la résiliation du Refuge Personnel, le droit de rétractation et les situations pouvant donner lieu à un remboursement."
      updatedAt={LEGAL_UPDATED_AT}
    >
      <LegalSection
        number="01"
        title="Annuler l’essai gratuit"
        highlight
      >
        <p>Lorsque vous bénéficiez de l’essai gratuit de sept jours, vous pouvez résilier depuis votre page Profil avant la fin de l’essai. Aucun prélèvement ne sera alors effectué.</p>
        <p>Après la demande, l’accès peut rester disponible jusqu’à la date de fin d’essai indiquée dans votre compte, mais l’abonnement ne doit pas être renouvelé en version payante.</p>
      </LegalSection>

      <LegalSection
        number="02"
        title="Résilier un abonnement payant"
      >
        <p>Vous pouvez résilier Le Refuge Personnel à tout moment depuis votre page Profil ou le portail client Stripe.</p>
        <ul className="legal-list">
          <li>La résiliation empêche le prochain renouvellement automatique.</li>
          <li>L’accès reste actif jusqu’à la fin de la période mensuelle ou annuelle déjà payée.</li>
          <li>Une résiliation ordinaire ne donne pas lieu à un remboursement au prorata de la période restante, sous réserve du droit de rétractation, de la garantie légale de conformité et des autres droits impératifs.</li>
        </ul>
      </LegalSection>

      <LegalSection
        number="03"
        title="Droit de rétractation"
      >
        <p>Vous disposez en principe d’un délai de quatorze jours à compter de la conclusion du contrat à distance pour notifier votre décision de vous rétracter.</p>
        <p>Pour un contenu numérique fourni immédiatement sans support matériel, ce droit ne peut être perdu avant la fin du délai que si Harmonauria a recueilli séparément votre accord préalable exprès pour commencer l’exécution et votre renoncement exprès au droit de rétractation, puis vous en a fourni confirmation sur un support durable.</p>
        <p>En l’absence de ces conditions, la rétractation reste possible dans les limites prévues par la loi.</p>
        <LegalCallout title="Pour exercer votre droit">
          <p>Envoyez votre déclaration avant la fin du délai à <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>. Vous n’avez pas à motiver votre décision.</p>
        </LegalCallout>
        <div className="legal-form-model">À l’attention de {LEGAL_CONTACT.publisherName}{"\n"}Adresse électronique : {LEGAL_CONTACT.email}{"\n\n"}Je vous notifie par la présente ma rétractation du contrat portant sur l’abonnement au Refuge Personnel souscrit le [date].{"\n\n"}Nom : [votre nom]{"\n"}Adresse électronique du compte : [votre adresse]{"\n"}Date : [date]</div>
      </LegalSection>

      <LegalSection
        number="04"
        title="Situations pouvant donner lieu à remboursement"
      >
        <ul className="legal-list">
          <li><strong>Rétractation valablement exercée :</strong> remboursement dans les conditions et délais prévus par la loi.</li>
          <li><strong>Prélèvement en double ou montant incorrect :</strong> remboursement après vérification du paiement concerné.</li>
          <li><strong>Défaut de conformité du service numérique :</strong> application des solutions prévues par la garantie légale, pouvant inclure une réduction du prix ou la résolution du contrat.</li>
          <li><strong>Indisponibilité technique grave et durable imputable à Harmonauria :</strong> examen de la demande en fonction de la durée, de l’impact et des solutions déjà proposées.</li>
          <li><strong>Renouvellement oublié :</strong> une demande présentée rapidement, idéalement dans les sept jours suivant le prélèvement, peut être examinée à titre commercial. Cette possibilité n’est ni automatique ni exclusive des droits légaux.</li>
        </ul>
      </LegalSection>

      <LegalSection
        number="05"
        title="Formule annuelle"
      >
        <p>La simple résiliation d’une formule annuelle ne donne pas lieu à un remboursement au prorata des mois restants. L’accès reste disponible jusqu’à l’échéance annuelle, sous réserve du droit de rétractation, de la garantie légale de conformité ou d’un geste commercial accepté par Harmonauria.</p>
      </LegalSection>

      <LegalSection
        number="06"
        title="Faire une demande"
      >
        <p>Adressez votre demande à <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a> avec l’adresse électronique du compte, la date du paiement, le montant et une description concise de la situation. N’envoyez jamais votre numéro complet de carte bancaire.</p>
        <p>Lorsque le remboursement est accepté, il est effectué sur le moyen de paiement d’origine. Le délai d’apparition dépend ensuite de Stripe et de l’établissement bancaire.</p>
      </LegalSection>

      <LegalSection
        number="07"
        title="Échec de paiement et suppression du compte"
      >
        <p>En cas d’échec de renouvellement, l’accès au Refuge Personnel peut être suspendu après les tentatives de paiement prévues par Stripe. Les informations de paiement peuvent être mises à jour depuis le portail client.</p>
        <p>Avant de supprimer votre compte, vérifiez que l’abonnement est bien résilié et que sa date d’effet est confirmée. La suppression du compte et la résiliation de l’abonnement sont deux opérations distinctes tant que le système ne confirme pas explicitement leur traitement conjoint.</p>
      </LegalSection>
    </LegalPageLayout>
  );
}
